import { SchemaId } from '#oaf_schema.registry';
import axios from 'axios';

// Update this if you make a breaking change that requires a new schema version
export const SCHEMA_VERSION: SchemaId = 'oafv1';

// Append session cookie with all requests
axios.defaults.withCredentials = true;

// Run-time configs
export const VERSION = process.env.VERSION || bundled.env.VERSION;
export const NODE_ENV = process.env.NODE_ENV || bundled.env.NODE_ENV;
export const NODE_VERSION = process.env.NODE_VERSION || bundled.env.NODE_VERSION;
export const IS_DEVELOPMENT = NODE_ENV !== 'production' && NODE_ENV !== 'test';
export const IS_PRODUCTION = NODE_ENV === 'production';
export const PUBLIC_URL = process.env.PUBLIC_URL || bundled.env.PUBLIC_URL || '/';
export const LOGGER_WSS_ENDPOINT = process.env.LOGGER_WSS_ENDPOINT || bundled.env.LOGGER_WSS_ENDPOINT;
export const REMOVE_NOTIFICATIONS_DELAY =
    parseInt(process.env.REMOVE_NOTIFICATIONS_DELAY || bundled.env.REMOVE_NOTIFICATIONS_DELAY || '0') || 0;
export const IMAGE_URL_PREFIX = process.env.IMAGE_URL_PREFIX || bundled.env.IMAGE_URL_PREFIX;
export const ASSET_STORAGE_URL = process.env.ASSET_STORAGE_URL || bundled.env.ASSET_STORAGE_URL;
export const PUBLISHING_SERVICE_URL = process.env.PUBLISHING_SERVICE_URL || bundled.env.PUBLISHING_SERVICE_URL;
export const TOKENLESS_REDIRECT_URL = process.env.TOKENLESS_REDIRECT_URL || bundled.env.TOKENLESS_REDIRECT_URL;
export const PACKAGES_SFDC_ORG_OAUTH_URL =
    process.env.PACKAGES_SFDC_ORG_OAUTH_URL || bundled.env.PACKAGES_SFDC_ORG_OAUTH_URL;
export const LOGOUT_REDIRECT_URL = process.env.LOGOUT_REDIRECT_URL || bundled.env.LOGOUT_REDIRECT_URL;
export const SUPPORT_URL = process.env.SUPPORT_URL || bundled.env.SUPPORT_URL;
export const PARTNER_COMMUNITY_URL = process.env.PARTNER_COMMUNITY_URL || bundled.env.PARTNER_COMMUNITY_URL;
export const COMMERCE_AUTH_URL = process.env.COMMERCE_AUTH_URL || bundled.env.COMMERCE_AUTH_URL;
export const STRIPE_CONNECT_URL = process.env.STRIPE_CONNECT_URL || bundled.env.STRIPE_CONNECT_URL;
export const STRIPE_CLIENT_ID = process.env.STRIPE_CLIENT_ID || bundled.env.STRIPE_CLIENT_ID;
export const PREVIEW_LISTING_URL = process.env.PREVIEW_LISTING_URL || bundled.env.PREVIEW_LISTING_URL;
export const SHOW_ANNOUNCEMENT_BANNER =
    process.env.SHOW_ANNOUNCEMENT_BANNER || bundled.env.SHOW_ANNOUNCEMENT_BANNER || 'false';
export const IN_MAINTENANCE = process.env.IN_MAINTENANCE === 'true' || bundled.env.IN_MAINTENANCE === 'true' || false;
export const SHOW_MAINTENANCE_BANNER =
    process.env.SHOW_MAINTENANCE_BANNER || bundled.env.SHOW_MAINTENANCE_BANNER || 'false';
export const MAINTENANCE_BANNER_STARTDATE =
    process.env.MAINTENANCE_BANNER_STARTDATE || bundled.env.MAINTENANCE_BANNER_STARTDATE;
export const MAINTENANCE_BANNER_ENDDATE =
    process.env.MAINTENANCE_BANNER_ENDDATE || bundled.env.MAINTENANCE_BANNER_ENDDATE;

if (SHOW_MAINTENANCE_BANNER === 'true' && (!MAINTENANCE_BANNER_STARTDATE || !MAINTENANCE_BANNER_ENDDATE)) {
    throw new Error(
        'SHOW_MAINTENANCE_BANNER is set to true, but MAINTENANCE_BANNER_STARTDATE, or MAINTENANCE_BANNER_ENDDATE env vars are missing. This is invalid.'
    );
}

// Build-time configs
export const DEFAULT_LANGUAGE = bundled.env.DEFAULT_LANGUAGE;

// Constants
export const SUPPORTED_IMAGE_FORMATS = ['JPG', 'PNG'];
export const SUPPORTED_RESOURCES_FORMATS = ['PDF'];
export const PRE_AUTH_REDIRECT_URL_LS_KEY = 'pre_auth_redirect_url';
export const MAX_ASSET_UPLOAD_SIZE = 5242880; // default 5mb
export const MAX_LISTINGS_QUERY_SIZE = 500;
export const SUPORTED_SRW_FILES_FORMATS = ['PDF', 'ZIP', 'PNG', 'JPG', 'DOC', 'CSV'];

// Feature Flag Config (getUnleash.io)
export const FEATURE_FLAG_PROXY_URL = process.env.FEATURE_FLAG_PROXY_URL || bundled.env.FEATURE_FLAG_PROXY_URL;
export const FEATURE_FLAG_CLIENT_KEY = process.env.FEATURE_FLAG_CLIENT_KEY || bundled.env.FEATURE_FLAG_CLIENT_KEY;
export const FEATURE_FLAG_APP_NAME = process.env.FEATURE_FLAG_APP_NAME || bundled.env.FEATURE_FLAG_APP_NAME;
export const FEATURE_FLAG_REFRESH_INTERVAL =
    process.env.FEATURE_FLAG_REFRESH_INTERVAL || bundled.env.FEATURE_FLAG_REFRESH_INTERVAL || 30;

// // If there is no url setup, we fall back to defaults. If there is however, we should have all the config
if (FEATURE_FLAG_PROXY_URL != null && (FEATURE_FLAG_CLIENT_KEY == null || FEATURE_FLAG_APP_NAME == null)) {
    throw new Error('Feature Toggle Integration is not completely configured.');
}
